import { useEffect } from "react";
import upgradeIcon from "./icons/upgrade.png";
import styles from "./WorkPage.module.scss";
import { PageTitleBlock } from "../../../components/PageTitleBlock/PageTitleBlock";
import { useDispatch } from "../../../hooks";
import { getWork } from "../../../redux/work/get-work.handler";
import { Battery } from "../Battery/Battery";
import { WorkContext } from "../WorkPage";
import { useContextNavigate } from "../../../hooks/navigate";
import { WorkButton } from "../WorkButton/WorkButton";
import { Highlightable } from "../../../components/Highlight/Highlightable";
import { ActionPromptType } from "../../../hooks/prompts";

export const WorkButtonPage = () => {    
    const navigate = useContextNavigate<WorkContext>();

    const upgradeClickHandler = () => navigate(WorkContext.Upgrade);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getWork());
    }, [dispatch]);

    return (
        <div className={styles.workWrapper}>
            <PageTitleBlock
                pageDescription={`К чему сложности - просто нажмите кнопку`}
            />

            <div className={styles.workTitle}></div>

            <WorkButton />

            <div className={styles.workButtonsWrapper}>
                <div className={styles.workButtons}>
                    <Battery />

                    <Highlightable promptType={ ActionPromptType.UPGRADE_WORK_ADD } >
                        <button
                            className={`${styles.workButton} ${styles.upgrades} `}
                            onClick={ upgradeClickHandler }
                        >
                            <img src={upgradeIcon} alt="Upgrade Icon" />
                            Улучшения
                        </button>
                    </Highlightable>
                </div>
            </div>
        </div>
    );
};